import { forwardRef, useEffect } from "react";
import HintArrow from "./HintArrow";
import Timeline from "./Timeline";
import { setActiveSection } from "../../store";
import { useDispatch } from "react-redux";
import SectionHeader from "./SectionHeader";

function TimelineSection({ preventIntersectionObserver }, ref) {
  const dispatch = useDispatch();

  /**
   * This is a callback to begin the observation of the div when the component first renders.
   */
  useEffect(() => {
    /**
     * An interaction observer object that allows us to monitor any interaction between the section's
     * div, and the viewport (visible area). It will make the section active when it intersects the
     * viewport.
     */
    const observer = new IntersectionObserver(
      (data) => {
        if (!preventIntersectionObserver.current && data[0].isIntersecting)
          dispatch(setActiveSection("experience"));
      },
      {
        root: null,
        threshold: [0.55],
        rootMargin: "0px 5px 0px 0px",
      }
    );
    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref, dispatch, preventIntersectionObserver]);

  return (
    <div
      className="h-full w-max relative pr-[200px] flex flex-row items-center ml-10"
      ref={ref}
    >
      <Timeline />
      <HintArrow className="absolute right-6 top-[45%]" />
      <SectionHeader text="My Journey" className="mr-36" />
    </div>
  );
}

export default forwardRef(TimelineSection);
